import { useState, useEffect } from 'react';

const TUTORIAL_STORAGE_KEY = 'hasTutorialBeenShown';

export const useTutorial = () => {
  const [shouldShowTutorial, setShouldShowTutorial] = useState(false);

  useEffect(() => {
    // Verificar se o tutorial já foi mostrado
    const hasBeenShown = localStorage.getItem(TUTORIAL_STORAGE_KEY);
    if (!hasBeenShown) {
      setShouldShowTutorial(true);
    }
  }, []);

  const completeTutorial = () => {
    localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
    setShouldShowTutorial(false);
  };

  const resetTutorial = () => {
    localStorage.removeItem(TUTORIAL_STORAGE_KEY);
    setShouldShowTutorial(true);
  };

  return {
    shouldShowTutorial,
    completeTutorial,
    resetTutorial
  };
}; 